// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#what-are-credits[data-v-c694f474]{border-radius:8px;background:linear-gradient(90deg,rgba(179,67,203,.12),rgba(112,149,235,.12))}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
